import { DateObject, dateObjectFromDate, getCurrentDateMinusMonths } from 'tabs/topQuestions/utils/DateUtils'
import {
  BeginClusteringResponse,
  CLUSTERING_UPDATE_IS_TRAINING,
  ClusteringStatus,
  LINE_CHART_FILTER_END_DATE_CHANGE,
  LINE_CHART_FILTER_START_DATE_CHANGE,
  QuestionClusteringStatusActions,
  START_CLUSTERING_REQ__REJECTED,
  START_CLUSTERING_REQ_PENDING,
  START_CLUSTERING_REQ_RESOLVED,
} from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusTypes'
import { PendingRequest, RequestStatus } from 'tabs/topQuestions/types/GenericTypes'
import { updateTrainingStatus } from 'tabs/topQuestions/lib/question_clustering_status/questionClusteringStatusActions'

export type ClusteringExecutionStatus = {
  status: 'PENDING' | 'RESOLVED' | 'REJECTED' | 'NONE'
  start: DateObject
  end: DateObject
}

export type ClusteringCheckStatus = { status: ClusteringStatus, n: number }

export type QuestionClusteringStatusSlice = {
  trainingClusters: Record<string, ClusteringCheckStatus>
  lienChartFilter: {
    startDate: DateObject | undefined,
    endDate: DateObject | undefined
  }
  beginClusteringRequest: PendingRequest<BeginClusteringResponse>

}

const initialState: QuestionClusteringStatusSlice = {
  trainingClusters: {},
  lienChartFilter: {
    startDate: dateObjectFromDate(getCurrentDateMinusMonths(1)),
    endDate: dateObjectFromDate(new Date(Date.now())),
  },
  beginClusteringRequest: {
    status: RequestStatus.NONE,
  },
}


export const questionClusteringStatusSlice = (
  state: QuestionClusteringStatusSlice = initialState,
  action: QuestionClusteringStatusActions): QuestionClusteringStatusSlice => {
  switch (action.type) {
    case LINE_CHART_FILTER_START_DATE_CHANGE:
      return {
        ...state,
        lienChartFilter: {
          startDate: action.payload,
          endDate: state.lienChartFilter.endDate,
        },
      }
    case LINE_CHART_FILTER_END_DATE_CHANGE:
      return {
        ...state,
        lienChartFilter: {
          startDate: state.lienChartFilter.startDate,
          endDate: action.payload,
        },
      }
    case START_CLUSTERING_REQ_PENDING:
      return {
        ...state,
        beginClusteringRequest: { status: RequestStatus.NONE },
      }
    case START_CLUSTERING_REQ_RESOLVED:
      return {
        ...state,
        beginClusteringRequest: { status: RequestStatus.RESOLVED, data: action.payload },
      }
    case START_CLUSTERING_REQ__REJECTED:
      return {
        ...state,
        beginClusteringRequest: { status: RequestStatus.REJECTED },
      }
    case CLUSTERING_UPDATE_IS_TRAINING:
      return {
        ...state,
        trainingClusters: updateTrainingStatus(state.trainingClusters, action.payload),
      }
    default:
      return state
  }
}
